<template>
  <bb-dropdown
    data-testid="account-filter"
    :aria-label="translations.selectAnAccount"
    display="block"
    gap="4"
  >
    <template #trigger>
      <bb-button
        data-testid="account-filter-button"
        size="lg"
        inverted
        color="black"
        display="block"
        icon-after="ui-menu-down"
        icon-after-color="gray-50"
        icon-after-fixed
        class="justify-content-between p-x-10 p-x-sm-20 f-align-left"
      >
        <div class="d-flex flex-column m-r-10 m-r-sm-20 f-smallest f-gotham-bold f-color-gray-90">
          <div class="d-flex flex-column flex-sm-row">{{ selectedAccount.iban }}</div>
          <div class="d-flex">
            <span class="f-gotham-book">{{ translations.availableBalance }} -&nbsp;</span>
            <span class="f-color-mint">{{ selectedAccount.formatedBalance }}</span>
          </div>
        </div>
        <bb-label
          data-testid="pending-payments-button-count"
          :aria-label="translations.numberOfPendingPayments"
          size="18"
          :value="selectedAccount.count"
          class="p-0 m-r-30 bg-gray f-smallest"
        />
      </bb-button>
    </template>
    <bb-dropdown-item
      v-for="account in accountOptions"
      :key="account.iban"
      @click="onAccountChange(account)"
      role="menuitem"
      class="d-flex justify-content-between p-x-10 p-x-sm-20 p-y-10 f-align-left"
    >
      <div class="d-flex flex-column m-r-10 m-r-sm-20 f-smallest f-gotham-bold f-color-gray-90">
        <div class="d-flex flex-column flex-sm-row">{{ account.iban }}</div>
        <div class="d-flex">
          <span class="f-gotham-book">{{ translations.availableBalance }} -&nbsp;</span>
          <span class="f-color-mint">{{ account.formatedBalance }}</span>
        </div>
      </div>
      <bb-label
        data-testid="pending-payments-option-count"
        :aria-label="translations.numberOfPendingPayments"
        size="18"
        :value="account.count"
        class="p-0 m-r-sm-30 bg-gray f-smallest"
      />
    </bb-dropdown-item>
  </bb-dropdown>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useAccountStore } from '@account/store/accountStore'
import { usePendingPaymentStore } from '@account/store/pendingPaymentStore'
import { formatMoneyWithCurrency } from '@/plugins/numformat'
import { useRootStore } from '@/store/root'

export default {
  name: 'account-filter',
  methods: {
    ...mapActions(usePendingPaymentStore, ['setSelectedIban', 'searchPendingPayments']),
    onAccountChange (account) {
      this.setSelectedIban(account.iban)
      this.searchPendingPayments()
    },
    waitingCount (iban) {
      return this.paymentCount?.accounts?.find(account => account.iban === iban)?.pendingPaymentsCount || 0
    }
  },
  computed: {
    ...mapState(useRootStore, ['locale', 'paymentCount']),
    ...mapState(useAccountStore, ['paymentAccounts']),
    ...mapState(usePendingPaymentStore, ['selectedIban']),
    translations () {
      return {
        availableBalance: this.$pgettext('pending_payment', 'Available balance'),
        numberOfPendingPayments: this.$pgettext('pending_payment', 'Number of pending payments for account'),
        selectAnAccount: this.$pgettext('pending_payment', 'Select an account')
      }
    },
    accountOptions () {
      if (!this.paymentAccounts) {
        return []
      }

      return this.paymentAccounts.map(account => ({
        ...account,
        count: this.waitingCount(account.iban) + '',
        formatedBalance: formatMoneyWithCurrency(account.availableBalance || 0, account.currencyCode, this.locale)
      }))
    },
    selectedAccount () {
      return this.accountOptions.find(account => account.iban === this.selectedIban)
    }
  }
}
</script>
